import { useEffect } from 'react';
import { DangerousHtmlContent } from '@eti/components';
import { useProperty, useTranslation } from '@eti/providers';
import { isDesktopViewport } from '../../utils/view';

const createAdFormBannersScriptTag = () => {
  const scriptTag = document.createElement('script');
  scriptTag.setAttribute('src', '//s1.adform.net/banners/scripts/adx.js');
  scriptTag.setAttribute('async', 'true');
  scriptTag.setAttribute('defer', 'true');
  return scriptTag;
};

const createAdFormMidScriptTag = (adFormMid) => {
  const scriptTag = document.createElement('script');
  scriptTag.setAttribute('data-adfscript', `adx.adform.net/adx/?mid=${adFormMid}`);
  return scriptTag;
};

const applyToDOM = (adFormMid) => {
  const wrapper = document.querySelector('.ad-content');
  wrapper.appendChild(createAdFormBannersScriptTag());
  wrapper.appendChild(createAdFormMidScriptTag(adFormMid));
};

const StartPageContent = () => {
  const { t } = useTranslation();
  const { p } = useProperty();

  useEffect(() => {
    const adFormMid = isDesktopViewport()
      ? p('IbeClient.Adform.StartPage.Desktop.Mid')
      : p('IbeClient.Adform.StartPage.Mobile.Mid');
    applyToDOM(adFormMid);
  }, [p]);

  return (
    <div data-testid="startPage-content">
      <DangerousHtmlContent content={t('StartPage.HtmlContent')} />
      <div className="ad-content" />
    </div>
  );
};

export default StartPageContent;
